import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import RecordingList from './components/recording-list';
import { authToken, teladocApi } from '@td/api';

const Recordings = ({ consultationId }) => {
  const [expanded, setExpanded] = useState(false);
  const [recordings, setRecordings] = useState([]);
  const [error, setError] = useState(false);

  const onExpand = () => {
    $('#recordings').slideToggle();
    setExpanded(!expanded);
  };
  useEffect(() => {
    teladocApi.get(`/v4/consultations/${consultationId}/conference_information`, null, authToken.get())
      .then(res => {
        return teladocApi.get(`/v4/media/conferences/${res.data.conference.id}/recordings`, null, authToken.get());
      })
      .then(res => {
        setRecordings(res.data.conferences);
      })
      .catch(() => {
        setError(true);
      });
  }, []);
  const wrapperClassName = `ct ${expanded ? 'expanded' : ''}`;
  return (
    <div className={wrapperClassName}>
      <h3 onClick={onExpand}>Recordings</h3>
      {
        !error ?
          <RecordingList recordings={recordings} containerStyle={{ display: 'none' }} />
        :
          <p>Failed to get the list of recordings</p>
      }
    </div>
  );
};

Recordings.propTypes = {
  consultationId: PropTypes.number.isRequired
};

export default Recordings;
